import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  StyledStudioEditorToolbar,
  StyledTextEditorToolbarFormatGroup,
  StyledStudioEditorToolbarText,
  StyledStudioEditorToolbarContent,
} from "../../../styled/details/stylesDetails";
import { connect } from "react-redux";
import { openAdvancedSettings } from "../../../../_actions/sidebarSliderActions";
import StudioCommonActions from "../../StudioCommonActions";
import {
  TldrAction,
  TldrBadge,
  TldrCustomIconAction,
} from "../../../common/statelessView";
import TextEditorToolbar from "../textEditorToolbar/TextEditorToolbar";
import { setActiveLayer } from "../../../../_actions/textToolbarActions";
import { v4 } from "uuid";
import {
  defaultTextItem,
  INTERACTION_PREVIEW,
  MASK_INTERACTION,
} from "../../../canvas/constants/defaults";
import ArtBoardHandler from "../../../common/artBoardHandlers/ArtBoardHandler";
import VideoEditorToolbar from "../videoEditorToolbar/VideoEditorToolbar";
import ImageEditorToolbar from "../imageEditorToolbar/ImageEditorToolbar";
import QuickCommonLayerActions from "../../layerActions/QuickCommonLayerActions";
import {
  ADVANCED_ANIMATION_PANEL,
  ADVANCED_EDITOR_EDIT,
  ADVANCED_EDITOR_PANEL,
  ADVANCED_EDITOR_RESIZE,
  FABRIC_PHOTOTEXT_ELEMENT,
} from "../../constants";
import { ReactComponent as IconMotion } from "../../../../assets/icons/motion.svg";
import { ReactComponent as ResizeMotion } from "../../../../assets/icons/resize.svg";
import { primary, white } from "../../../styled/variable";
import PhotoTextEditorToolbar from "../textEditorToolbar/PhotoTextEditorToolbar";
import { BottomPanelViewTypes } from "../../../../_utils/constants";
import {
  FaCheck,
  FaChevronDown,
  FaChevronUp,
  FaEllipsisH,
  FaEllipsisV,
  FaLayerGroup,
  FaMagic,
  FaTimes,
  FaTrash,
} from "react-icons/fa";
import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Button,
  Icon,
} from "@chakra-ui/react";
import { withTranslation } from "react-i18next";

class StudioEditorToolbar extends Component {
  constructor(props) {
    super(props);
    this.contentRef = React.createRef();
    this.state = {
      showArrangeActionsOverlay: false,
    };
  }

  advancedSettings = () => {
    this.props.openAdvancedSettings(
      ADVANCED_EDITOR_PANEL,
      ADVANCED_EDITOR_EDIT
    );
  };

  openResizeArtboardTab = () => {
    this.props.openAdvancedSettings(
      ADVANCED_EDITOR_PANEL,
      ADVANCED_EDITOR_RESIZE
    );
  };

  showMotionsPanel = () => {
    this.props.openAdvancedSettings(
      ADVANCED_ANIMATION_PANEL,
      ADVANCED_EDITOR_EDIT
    );
  };

  render() {
    const { editor, canvasRef, rightsidebar, bottomPanel, pagestore, t } =
      this.props;
    const { activeElement, activePage, activeSelection } = editor;
    const { isActionPanelOpen } = rightsidebar;
    const { viewType: bottomPanelViewType } = bottomPanel;
    const hasOverflown =
      this?.contentRef?.current?.clientWidth <
      this?.contentRef?.current?.scrollWidth;

    const hideView =
      !(activeElement.id || activePage.isSelected || activeSelection.mime) ||
      bottomPanelViewType === BottomPanelViewTypes.ARTBOARDS_GRID_VIEW ||
      isActionPanelOpen;

    const pageIndex = this.props.editor.activePage.pageIndex;
    const page = pagestore.pages[this.props.editor.activePage.id];

    if (canvasRef?.handler?.interactionMode === INTERACTION_PREVIEW) {
      return null;
    }

    return (
      <>
        <StyledStudioEditorToolbar
          id="tldr-toolbar"
          hidden={hideView}
          ref={this.contentRef}
          style={
            this.props.isMobileView
              ? { alignItems: hasOverflown ? "flex-start" : "center" }
              : {}
          }
        >
          <StyledStudioEditorToolbarText>
            {canvasRef?.handler?.interactionMode === MASK_INTERACTION
              ? "Text Mask"
              : activeElement.format?.type === FABRIC_PHOTOTEXT_ELEMENT
              ? "Photo Text"
              : activeElement.mime
              ? activeElement.mime
              : activeSelection.mime
              ? activeSelection.mime
              : activePage
              ? page?.title ?? `Artboard ${pageIndex + 1}`
              : ""}
          </StyledStudioEditorToolbarText>
          <StyledStudioEditorToolbarContent>
            <StudioCommonActions
              artBoardHandlers={this.props.artBoardHandler}
              canvasRef={canvasRef}
            >
              {activeElement.mime === "text" &&
              activeElement.format?.type === FABRIC_PHOTOTEXT_ELEMENT ? (
                <PhotoTextEditorToolbar canvasRef={canvasRef} />
              ) : activeElement.mime === "text" ? (
                <TextEditorToolbar canvasRef={canvasRef} />
              ) : null}

              {activeElement.mime === "image" && (
                <ImageEditorToolbar canvasRef={canvasRef} useSuspense={false} />
              )}

              {activeElement.mime === "video" && (
                <VideoEditorToolbar canvasRef={canvasRef} />
              )}
            </StudioCommonActions>

            <StyledTextEditorToolbarFormatGroup>
              {activeSelection.mime === "selection" ? (
                <></>
              ) : (
                !activeElement.mime &&
                canvasRef?.handler?.interactionMode === "selection" && (
                  <TldrAction
                    action={{}}
                    icon={<ResizeMotion fill={white}/>}
                    title={t("resize")}
                    callback={this.openResizeArtboardTab}
                  />
                )
              )}

              {activeElement.mime !== "selection" &&
                canvasRef?.handler?.interactionMode === "selection" && (
                  <TldrBadge>
                    <TldrCustomIconAction
                      title={t("animate")}
                      action={activeElement.mime}
                      icon={<IconMotion fill={white} />}
                      callback={this.showMotionsPanel}
                    />
                  </TldrBadge>
                )}
            </StyledTextEditorToolbarFormatGroup>

            {activeElement.mime && !activeElement.cropEnable && (
              <>
                {!this.props.isMobileView && <div className="tldr-vl" />}
                {
                  <Popover
                    isLazy
                    placement={this.props.isMobileView ? "top-end" : "bottom"}
                    onOpen={() =>
                      this.setState({ showArrangeActionsOverlay: true })
                    }
                    onClose={() =>
                      this.setState({ showArrangeActionsOverlay: false })
                    }
                  >
                    <PopoverTrigger>
                      <Button variant="unstyled" mx={2} size="sm" display="inherit">
                        <Icon
                          as={FaLayerGroup}
                          w={"1.3em"}
                          h={"1.3em"}
                          color={
                            this.state.showArrangeActionsOverlay && primary
                          }
                        />
                        &nbsp;
                        {this.state.showArrangeActionsOverlay ? (
                          <FaChevronUp
                            color={
                              this.state.showArrangeActionsOverlay && primary
                            }
                          />
                        ) : (
                          <FaChevronDown />
                        )}
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent width={"100%"}>
                      <PopoverArrow />
                      <PopoverBody>
                        <QuickCommonLayerActions
                          canvasRef={canvasRef}
                          isPositionSidebar={false}
                          showOrderOptions={true}
                          showFlipOptions={true}
                        />
                      </PopoverBody>
                    </PopoverContent>
                  </Popover>
                }
                {!this.props.isMobileView && <div className="tldr-vl" />}
              </>
            )}

            {!activeSelection.mime &&
              !activeElement.cropEnable &&
              canvasRef?.handler?.interactionMode === "selection" && (
                <StyledTextEditorToolbarFormatGroup>
                  <TldrAction
                    action="advanced"
                    icon={
                      this.props.isMobileView ? (
                        <FaEllipsisV />
                      ) : (
                        <FaEllipsisH />
                      )
                    }
                    title={t("more")}
                    margin={this.props.isMobileView ? "0 4px 0 4px" : ""}
                    callback={this.advancedSettings}
                  />
                </StyledTextEditorToolbarFormatGroup>
              )}

            {!activeSelection.mime &&
              canvasRef?.handler?.interactionMode === MASK_INTERACTION && (
                <StyledTextEditorToolbarFormatGroup>
                  <TldrAction
                    action={{}}
                    icon={<FaCheck />}
                    title={t("apply_mask")}
                    callback={this.applyMask}
                  />

                  <TldrAction
                    action={{}}
                    icon={<FaTimes />}
                    title={t("cancel_mask")}
                    callback={this.cancelMask}
                  />
                  {!this.props.isMobileView && <div className="tldr-vl" />}

                  <TldrAction
                    action="delete"
                    icon={<FaTrash />}
                    title={t("remove_mask")}
                    callback={this.removeMask}
                  />
                </StyledTextEditorToolbarFormatGroup>
              )}
          </StyledStudioEditorToolbarContent>
        </StyledStudioEditorToolbar>
      </>
    );
  }

  applyMask = () => {
    this.props.canvasRef.handler.maskHandler.finish();
  };

  cancelMask = () => {
    this.props.canvasRef.handler.maskHandler.cancel();
  };

  removeMask = () => {
    this.props.canvasRef.handler.maskHandler.delete();
  };

  componentDidMount() {
    if (this.props.canvasRef) {
      this.artBoardHandlers = new ArtBoardHandler(this.props.canvasRef.handler);
    }
  }

  addText = () => {
    this.handlers.onAddItem(defaultTextItem, true);
  };

  handlers = {
    onAddItem: (item, centered) => {
      const { canvasRef } = this.props;
      if (canvasRef.handler.interactionMode === "polygon") {
        // message.info('Already drawing');
        return;
      }
      const id = v4();
      const option = Object.assign({}, item.option, { id });
      // if (item.option.superType === "svg" && item.type === "default") {
      //   this.handlers.onSVGModalVisible(item.option);
      //   return;
      // }
      canvasRef.handler.add(option, centered);
    },
  };
}

StudioEditorToolbar.propTypes = {
  editor: PropTypes.object.isRequired,
  openAdvancedSettings: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  editor: state.editor,
  layers: state.layerstore.layers,
  pagestore: state.pagestore,
  rightsidebar: state.rightsidebar,
  bottomPanel: state.bottomPanel,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  openAdvancedSettings: (panel, selectedTab) =>
    dispatch(openAdvancedSettings(panel, selectedTab)),
  setActiveLayer: (elementId, elementType, elementFormat, elementParentId) =>
    dispatch(
      setActiveLayer(elementId, elementType, elementFormat, elementParentId)
    ),
});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(StudioEditorToolbar)
);
